<template>
  <div class="result-main">
<!--    <div class="no-result"></div>-->
    <div class="result">
      <div class="result-num">
        <span>本次检索为您找到</span>
        <span class="num">{{sum}}</span>
        <span>篇有关</span>
        <span class="kw">{{kw}}</span>
        <span>的页面</span>
      </div>
      <div class="content">
        <search-column :fl-details="result.sum" @b-content="getChildContent" :now-column="nowColumn"/>
        <div class="result-list">
          <div class="list-content">
            <div class="list-title">{{childContent}}</div>
            <div v-for="item in result.data" :key="item.id" class="l-c">
              <div class="news-box" @click="toDetail(item.id)">
                <span class="box-title">{{item.title}}</span>
                <span class="box-content">{{item.summary}}</span>
                <span class="date">{{item.release_time}}</span>
              </div>
              <div class="line"></div>
            </div>
          </div>
          <div class="pagination" v-if="result.data.length">
            <el-pagination
                    background
                    layout="prev, pager, next, jumper"
                    :page-count="result.total"
                    :pager-count="7"
                    :current-page.sync="currentPage"
                    @current-change= "getNewData"
            >
            </el-pagination>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import SearchColumn from "../components/common/SearchColumn";
  import {resultList} from "../api";
  export default {
    name: "SearchResult",
    components: {
      SearchColumn
    },
    data() {
      return {
        sum: 0,
        currentPage: 1,
        nowColumn: 1,
        contentDetail: ['侨联概况', '党的建设', '工作动态', '为侨服务', '品牌活动'],
        kw: '',
        result: {
          sum: {},
          data: []
        },
        childContent: '侨联概况'
      }
    },
    methods: {
      toDetail(id) {
        let routeData = this.$router.resolve({
          path: '/article',
          query: {ArticleId: id}
        })
        window.open(routeData.href, '_blank');
      },
      getNewData() {
        let query = {
          label: this.childContent,
          kw: this.kw
        }
        resultList(this.currentPage, query).then(res=> {
          this.result = res.data
        })
      },
      getChildContent(data) {
        this.currentPage = 1
        this.childContent = this.contentDetail[data - 1]
        this.nowColumn = data
        const query = {
          label: this.childContent,
          kw: this.kw
        }
        resultList(1,query).then(res=> {
          this.result = res.data
        })
      },
      getData() {
        this.childContent = '侨联概况'
        this.kw = this.$route.query.kw
        if(!this.kw){
          return
        }
        const query = {kw: this.kw}
        resultList(1,query).then(res=> {
          // console.log(res);
          this.result = res.data
          this.sum = res.data.sum.ba +res.data.sum.overview + res.data.sum.pb + res.data.sum.sc + res.data.sum.wd
        })
      }
    },
    created() {
      this.kw = this.$route.query.kw
      this.getData()
    },
    watch: {
      '$route':'getData'
    }
  }
</script>

<style scoped lang="scss">
.result-main {
  width: 1000px;
  margin: 60px auto 0;
  min-height: 500px;
  align-items: flex-start;
  .result {
    width: 100%;
    display: flex;
    flex-direction: column;
    .result-num {
      display: flex;
      flex-direction: row;
      justify-self: flex-start;
      /*max-width: 700px;*/
      font-family: 'SourceHanSansCN-Regular';
      font-size: 16px;
      font-weight: normal;
      font-stretch: normal;
      letter-spacing: 0;
      color: #656565;
      .num {
        color: #d43e42
      }
      .kw {
        color: #d43e42;
        width: 300px;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
        word-break: break-all;
      }
    }
    .content {
      margin-top: 30px;
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      .result-list {
        width: 800px;
        border: solid 1px #d9d9d9;
        border-top: solid 1px #d43e42;
        background-color: #f9f9f9;
        .list-content {
          width: 758px;
          display: flex;
          flex-direction: column;
          margin: 0 auto;
          border-bottom: solid 1px #d9d9d9;
          /*.l-c {*/
          /*  display: flex;*/
          /*  flex-direction: column;*/
          /*  justify-content: flex-start;*/
          /*}*/
          .list-title {
            height: 40px;
            line-height: 40px;
            font-family: 'SourceHanSerifCN-Bold';
            font-size: 18px;
            font-weight: normal;
            font-stretch: normal;
            letter-spacing: 0;
            color: #d43e42;
          }
          .line {
            width: 100%;
            height: 1px;
            background-color: #d9d9d9;
          }
          .news-box {
            cursor: pointer;
            margin-top: 20px;
            width: 100%;
            height: 175px;
            display: flex;
            flex-direction: column;
            justify-content: flex-start;
            align-items: center;
            .box-title {
              width: 100%;
              height: 50px;
              font-family: 'SourceHanSansCN-Regular';
              font-size: 18px;
              font-weight: normal;
              font-stretch: normal;
              color: #282828;
              overflow: hidden;
              text-overflow: ellipsis;
              display: -webkit-box;
              -webkit-line-clamp: 2;
              line-clamp: 2;
              -webkit-box-orient: vertical;
              line-height: 28px;
            }
            .box-content {
              width: 720px;
              height: 75px;
              font-family: Alibaba-PuHuiTi-R;
              font-size: 16px;
              font-weight: normal;
              font-stretch: normal;
              letter-spacing: 0;
              color: #656565;
              overflow: hidden;
              text-overflow: ellipsis;
              display: -webkit-box;
              -webkit-line-clamp: 3;
              line-clamp: 3;
              -webkit-box-orient: vertical;
              line-height: 25px;
            }
            .date {
              font-family: 'SourceHanSansCN-Regular';
              font-size: 18px;
              font-weight: normal;
              font-stretch: normal;
              color: #282828;
              align-self: flex-end;
              height: 18px;
              margin-bottom: 12px;
            }
          }
        }
        .pagination {
          text-align: center;
          margin-top: 50px;
          ::v-deep .el-pager li:not(.disabled).active {
            background-color: #e9e9e9;
            color: #000;
          }
        }
      }
    }
  }
}
</style>
